const mainBody = document.body


//detect when mobile
function isMobileOrTablet() {
    return window.matchMedia('(max-width: 1023px)').matches
}

//function to wait for any element chosen by query, when element appears it is returned
function waitForElement(query, autoDisconnect = true, autoDisconnectMs = 5000, root = document.body) {
    return new Promise((resolve) => {
        function findElement() {
            if (query.includes(" >> ")) {
                // Shadow DOM traversal support
                const parts = query.split(" >> ");
                let currentRoot = root;

                for (const part of parts) {
                    if (!currentRoot) return null;
                    currentRoot = currentRoot instanceof ShadowRoot ? currentRoot.querySelector(part) : currentRoot.querySelector(part);
                    if (currentRoot?.shadowRoot) {
                        currentRoot = currentRoot.shadowRoot; // Move into shadow root if it exists
                    }
                }
                return currentRoot;
            } else {
                // Standard query for non-shadow elements
                return root.querySelector(query);
            }
        }

        let awaitedElement = findElement();
        if (awaitedElement) return resolve(awaitedElement);

        const observer = new MutationObserver(() => {
            awaitedElement = findElement();
            if (awaitedElement) {
                disconnectAndResolve();
            }
        });

        observer.observe(root, { childList: true, subtree: true });

        function disconnectAndResolve(hasElement = true) {
            observer.disconnect();
            return hasElement ? resolve(awaitedElement) : resolve(null);
        }

        if (autoDisconnect) {
            setTimeout(() => {
                disconnectAndResolve(false);
            }, autoDisconnectMs);
        }
    });
}


//standard lazy loading for images main function
function lazyLoading() {
    let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {

                    let lazyImage = entry.target;

                    loadLazyImg(lazyImage)
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    }
}

//add mouseover listener for lazy load on hover function
function hoverLazyLoading() {
    let lazyOnHoverImages = [].slice.call(document.querySelectorAll("img.lazy-on-hover"));

    lazyOnHoverImages.forEach((lazyHoverImg) => {
        lazyHoverImg.closest('.lazy-hover-container').addEventListener('mouseover', loadLazyImgOnHover, {once: true})
    })
}

//function to lazy load on hover
function loadLazyImgOnHover(evt) {

    let eTarget = evt.target
    if (!eTarget.classList.contains('lazy-hover-container')) eTarget = eTarget.closest('.lazy-hover-container')

    let lazyImg = eTarget.querySelector('.lazy-on-hover')

    loadLazyImg(lazyImg)
}

//lazy load function for images
function loadLazyImg(lazyImgEl) {

    lazyImgEl.src = lazyImgEl.dataset.src;
    lazyImgEl.srcset = lazyImgEl.dataset.srcset;
    setTimeout(() => {
        lazyImgEl.classList.remove("lazy");
        lazyImgEl.parentElement.classList.remove('loading')
    })
}

function customAnimate(el) {
    el.classList.add(el.dataset.animation)
}

function customAnimateOnScroll() {
    let allAnimatedElements = document.querySelectorAll('[data-animation]')
    let counter = 0

    let observerCallback = (entries, observer) => {

        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                customAnimate(entry.target)
                observer.observe(entry.target)
                counter++

                if (counter === allAnimatedElements.length) {
                    observer.disconnect()
                }
            }
        })
    }

    let observer = new IntersectionObserver(observerCallback);

    allAnimatedElements.forEach((el) => {

        observer.observe(el)
    })
}

function removeAllCustomAnimations() {

    let allAnimatedElements = document.querySelectorAll('[data-animation]')
    allAnimatedElements.forEach(el => {
        el.removeAttribute('data-animation')
    })
}

function toggleMenuOptions() {
    if (!isMobileOrTablet()) {
        const navigationElements = document.querySelectorAll('.widemenu__submenu.ul > .widemenu__link');

        navigationElements.forEach(el => {
            el.addEventListener('mouseenter', () => {
                navigationElements.forEach(elInLoop => {
                    elInLoop.classList.toggle('open', el === elInLoop);
                });
            });
        });
    }
}


//append plugin's product options
async function appendProductOptions() {

    const productOptionsContainer = document.querySelector('.product-block.product-block--options')
    const newOptions = await waitForElement('.purchase-details .ef__product-option-root')

    if(productOptionsContainer && newOptions){
        console.debug('appended')
        productOptionsContainer.innerHTML = ''
        productOptionsContainer.appendChild(newOptions)

        newOptions.style.display = 'block'
    }
}

//all custom widget basic and shared functions
const customWidgetFunctions = {

    //detect widget smart tab container on page
    async getSmartTabContainer(widgetEl, widgetType) {
        //if product page
        if (mainBody.dataset.template === 'product') {

            //wait for smart tabs and get container
            let smartTabs = await waitForElement('.smart-tabs-wrapper', false)
            if (smartTabs) {
                customWidgetFunctions.assignWidgetContainer(widgetEl, smartTabs, widgetType)
                if (widgetEl.container) widgetEl.container.innerHTML = ''
            }

        }
    },
    //detect widget container
    assignWidgetContainer(widgetEl, parent, widgetType) {
        widgetEl.container = parent.querySelector('div[data-custom-element=' + widgetType + ']')
    },
    //append widget to detected container
    appendWidget(widgetEl) {
        widgetEl.container?.append(widgetEl)
    },
    //show widget
    showWidget(widgetEl) {
        widgetEl.classList.remove('mf-hide')
    },
    //check if widget is active
    widgetIsActive(widgetEl) {
        return widgetEl.classList.contains('js-activate')
    },
    //hide tab
    hideTab(widgetEl) {

        const tabNumber = widgetEl.container.parentElement.id[widgetEl.container.parentElement.id.length - 1]
        const tabHeading = document.querySelector(`[data-tab-link-id="${tabNumber}"]`)
        tabHeading.style.display = 'none'
    }

}

/*//custom sizes widget definition
class CustomSizesWidget extends HTMLElement {
    constructor() {
        super();

        if (customWidgetFunctions.widgetIsActive(this)) {
            customWidgetFunctions.getSmartTabContainer(this, 'custom-sizes-widget').then(() => {
                    if (this.container) customWidgetFunctions.appendWidget(this)
                    customWidgetFunctions.showWidget(this)
                }
            )
        }
    }
}

customElements.define('custom-sizes-widget', CustomSizesWidget)*/

//custom finishes widget definition
class CustomFinishesWidget extends HTMLElement {
    constructor() {
        super();
        if (customWidgetFunctions.widgetIsActive(this)) {

            this.linkButtonsToContainers()

            customWidgetFunctions.getSmartTabContainer(this, 'custom-finishes-widget').then(() => {
                    if (this.container) {
                        if (this.hasAttribute('no-configuration')) {
                            customWidgetFunctions.hideTab(this)
                        } else {
                            customWidgetFunctions.appendWidget(this)
                            customWidgetFunctions.showWidget(this)
                        }
                    }
                }
            )
        }
    }

    //link buttons to relative options container and listen for click event
    linkButtonsToContainers() {

        this.categoryButtons = this.querySelectorAll('[data-finishes-category]')
        this.optionsContainers = this.querySelectorAll('[data-finishes-options]')

        this.optionsContainers.forEach((container) => {
            container.category = container.dataset.finishesOptions
        })

        this.categoryButtons.forEach((button) => {
            button.category = button.dataset.finishesCategory
            button.addEventListener('click', (evt) => {
                evt.preventDefault()

                if (!button.classList.contains('active')) this.switchCategory(button)

            })
        })
    }

    //switch between categories
    switchCategory(button) {

        this.categoryButtons.forEach((genericButton) => {
            if (genericButton !== button) {
                genericButton.classList.remove('active')
            } else {
                genericButton.classList.add('active')
            }
        })

        setTimeout(() => {
            this.optionsContainers.forEach((container) => {
                if (container.category === button.category) {
                    container.classList.add('active')
                } else {
                    container.classList.remove('active')
                }
            })
        }, 300)

    }

}

customElements.define('custom-finishes-widget', CustomFinishesWidget)

//custom delivery time widget
class CustomDeliveryTimeWidget extends HTMLElement {
    constructor() {
        super();

        customWidgetFunctions.assignWidgetContainer(this, document, 'custom-delivery-time-widget')
        customWidgetFunctions.appendWidget(this);
    }

}

customElements.define('custom-delivery-time-widget', CustomDeliveryTimeWidget)

//custom product details widget definition
class CustomDetailsWidget extends HTMLElement {
    constructor() {
        super();

        if (customWidgetFunctions.widgetIsActive(this)) {

            customWidgetFunctions.getSmartTabContainer(this, 'custom-details-widget').then(() => {
                    if (this.container) {
                        this.tableHasData = Array.from(this.children).some(child => child.children.length > 0);
                        if (!this.tableHasData) {
                            customWidgetFunctions.hideTab(this)
                        } else {

                            customWidgetFunctions.appendWidget(this)
                            //show details widget only if a smart tabs container is present
                            customWidgetFunctions.showWidget(this)

                            this._onVariantChangedListener = this._onVariantChanged.bind(this);
                            const allForms = [...document.forms]
                            this.productForm = allForms.find(form => form.closest('.product-main-cta') && form.action.includes('cart/add'))
                            if (this.productForm) {
                                this.productForm?.addEventListener("variant:change", this._onVariantChangedListener);
                            }

                        }
                    }

                }
            )
        }
    }

    _onVariantChanged() {
        const variantId = this.productForm?.querySelector('select[name="id"]').value ? Number(this.productForm?.querySelector('select[name="id"]').value) : null;
        if (variantId) Array.from(this.children).forEach((item) => {
            item.toggleAttribute("hidden", variantId !== parseInt(item.getAttribute("data-variant-id")))
        });
    }

}

customElements.define('custom-details-widget', CustomDetailsWidget)

//custom product downloads widget
class CustomProductDownloads extends HTMLElement {
    constructor() {
        super();

        //if smart tab is present:
        // If files are uploaded or linked, append to the container and show the widget,
        // Otherwise hide smart tab
        if (customWidgetFunctions.widgetIsActive(this)) {

            customWidgetFunctions.getSmartTabContainer(this, 'custom-product-downloads').then(async () => {
                    if (this.container) {
                        this.fileNodes = this.querySelectorAll('.download-module')
                        for (const fileNode of this.fileNodes) { // Use for...of loop for async/await
                            fileNode.link = fileNode.querySelector('a');
                            if (fileNode.link.href.includes('youtu')) {
                                fileNode.fileTitle = await this.fetchTitle(fileNode.link.href); // 'await' works here
                                fileNode.extension = 'video';
                                fileNode.link.innerText = 'Watch';
                            } else {
                                fileNode.completeName = this.generateCompleteFileName(fileNode.link.href);
                                fileNode.fileTitle = this.getTitle(fileNode.completeName);
                                fileNode.extension = this.getFileExtension(fileNode.completeName);
                            }

                            const typeEl = fileNode.querySelector('.download-module__type')
                            const titleEl = fileNode.querySelector('.download-module__title')
                            //const sizeEl = fileNode.querySelector('.download-module__size span')

                            typeEl.innerHTML = fileNode.extension
                            titleEl.innerHTML = fileNode.fileTitle
                            //this.getFileSize(fileNode.link.href, sizeEl)
                        }

                        if (this.fileNodes.length) {
                            customWidgetFunctions.appendWidget(this)
                            //show details widget only if a smart tabs container is present
                            customWidgetFunctions.showWidget(this)
                        } else {
                            customWidgetFunctions.hideTab(this)
                        }
                    }
                }
            )
        }

    }

    getFileSize(link, sizeNode) {
        fetch(link, {
            mode: "no-cors"
        }).then(r => r.blob()).then(blobObj => {
            const sizeData = blobObj.size
            let sizeString
            if (sizeData >= 1000000) {
                sizeString = (sizeData / 1000000).toFixed(2) + ' MB'
            } else {
                sizeString = (sizeData / 1000).toFixed(2) + ' KB'
            }
            sizeNode.innerHTML = sizeString
        })
    }

    //generate file name with extension included
    generateCompleteFileName(url) {
        const start = url.lastIndexOf('/')

        let end
        if (url.includes('?')) end = url.indexOf('?')
        else end = url.length
        return url.substring(start + 1, end)
    }

    //get only file title
    getTitle(completeFileName) {
        const lastDotIndex = completeFileName.lastIndexOf('.')

        let title
        if (completeFileName.includes('_')) title = completeFileName.substring(0, completeFileName.indexOf('_'))
        else title = completeFileName

        return title.substring(0, lastDotIndex).replaceAll('-', ' ')
    }

    //get file extension
    getFileExtension(completeFileName) {
        const lastDotIndex = completeFileName.lastIndexOf('.')
        return completeFileName.substring(lastDotIndex + 1)
    }

    async fetchTitle(url) {
        const query = `https://www.youtube.com/oembed?url=${url}&format=json`

        let title = ''
        await fetch(query).then(response => response.json()).then((data) => {
            title = data.title
        })

        return title
    }

}

customElements.define('custom-product-downloads', CustomProductDownloads)

//custom product videos widget
class CustomProductVideos extends HTMLElement {
    constructor() {
        super();

        //if smart tab is present:
        // If files are uploaded or linked, append to the container and show the widget,
        // Otherwise hide smart tab
        if (customWidgetFunctions.widgetIsActive(this)) {

            customWidgetFunctions.getSmartTabContainer(this, 'custom-product-videos').then(async () => {
                    if (this.container) {
                        this.fileNodes = this.querySelectorAll('iframe')

                        if (this.fileNodes.length) {
                            customWidgetFunctions.appendWidget(this)
                            //show details widget only if a smart tabs container is present
                            customWidgetFunctions.showWidget(this)
                        } else {
                            customWidgetFunctions.hideTab(this)
                        }
                    }
                }
            )
        }

    }

}

customElements.define('custom-product-videos', CustomProductVideos)

//custom enquiry widget definition
class CustomEnquiryWidget extends HTMLElement {
    constructor() {
        super();

        if (customWidgetFunctions.widgetIsActive(this)) {

            customWidgetFunctions.getSmartTabContainer(this, 'custom-enquiry-widget').then(() => {
                    if (this.container) {
                        customWidgetFunctions.appendWidget(this)
                        //show details widget only if a smart tabs container is present
                        customWidgetFunctions.showWidget(this)
                    }
                }
            )
        }
    }

}

customElements.define('custom-enquiry-widget', CustomEnquiryWidget)

//custom minimum order widget definition
class CustomMinimumOrderWidget extends HTMLElement {
    constructor() {
        super();
        this.overlay = this.querySelector('.custom-minimum-order-widget__container')
        this.minusButton = this.parentElement.querySelector('span.product-minus.js-change-quantity, .quantity__button[name="minus"]')
        this.numberInput = this.parentElement.querySelector('input[type=number].quantity')
        this.moqString = this.querySelector('.moq-string')

        this.minimumQuantity = Number(this.dataset.moq) || this.numberInput.min

        //update numeric input value if less than moq
        if (Number(this.numberInput.value) < this.minimumQuantity) this.numberInput.value = this.minimumQuantity

        if (this.minimumQuantity > 1) {

            this.boundConditionalClose = this.conditionalClose.bind(this);


            // Bind the closeOverlay method and store the reference
            this.boundCloseOverlay = this.closeOverlay.bind(this);

            this.minusButton.addEventListener('click', (event) => {
                //refresh minimum quantity in case dynamic content is provided
                this.minimumQuantity = Number(this.dataset.moq) || this.numberInput.min
                if (Number(this.numberInput.value) < this.minimumQuantity) this.numberInput.value = this.minimumQuantity

                if (this.moqString.innerText !== this.minimumQuantity) this.moqString.innerText = this.minimumQuantity


                if (Number(this.numberInput.value) === this.minimumQuantity) {
                    event.stopImmediatePropagation();
                    if (!this.overlay.classList.contains('show')) {
                        this.showOverlay()
                        setTimeout(() => document.addEventListener('click', (evt) => {
                            if (evt.target !== this.minusButton && !evt.target.closest('.product-minus.js-change-quantity')) {
                                this.boundCloseOverlay()
                            }
                        }))
                    }
                }

            }, true)
        }
    }

    showOverlay() {
        this.overlay.classList.add('show')
        this.closeTimeoutId = setTimeout(this.boundCloseOverlay, 8000)

        // Add the conditional close event listener to the document
        setTimeout(() => document.addEventListener('click', this.boundConditionalClose));
    }

    closeOverlay() {
        this.overlay.classList.remove('show')
        // Clear the timeout to prevent it from running if the overlay is already closed
        if (this.closeTimeoutId) {
            clearTimeout(this.closeTimeoutId);
        }

        // Remove the conditional close event listener from the document
        document.removeEventListener('click', this.boundConditionalClose);
    }

    conditionalClose(evt) {
        if (!evt.target.closest('.product-minus.js-change-quantity')) {
            this.boundCloseOverlay();
        }
    }

}

customElements.define('custom-minimum-order-widget', CustomMinimumOrderWidget)


document.addEventListener("DOMContentLoaded", () => {
    toggleMenuOptions()
    appendProductOptions()
    if (mainBody.dataset.template === 'product') {
        waitForElement('.smart-tabs-wrapper', false).then(() => {

                // hide loader when smart tabs kicks in
                const smartTabsLoader = mainBody.querySelector('.smart-tabs-custom-loader')
                smartTabsLoader?.classList.add('mf-hide')

                lazyLoading()
                if (!isMobileOrTablet()) hoverLazyLoading()
            }
        )
    } else {
        lazyLoading()
    }
    //when page gets visible
    if (mainBody.classList.contains('page-transition')) {
        window.addEventListener('pageshow', () => {
            //kick in animations when element enters viewport
            customAnimateOnScroll()
        })
    } else {
        customAnimateOnScroll()
    }

})

// Formspark forms: submit in the background and show the thank-you message on the page.
// Restored 2026-10-09 – this class was missing from the live theme.
class CustomFormsparkForm extends HTMLElement {
    constructor() {
        super();
        this._form = null;
        this._onSubmit = this._onSubmit.bind(this);
    }

    connectedCallback() {
        // Use the first descendant <form> you authored in the light DOM
        this._form = this.querySelector("form");
        if (!this._form) {
            console.error("[custom-formspark-form] No <form> found inside element.");
            return;
        }

        this.verifyNotRobotTxt = this.getAttribute("verify-not-robot-message") || "";
        this.captchaNotReadyTxt = this.getAttribute("captcha-not-ready-message") || "";

        // NEW: cache result elements
        this._result = this.querySelector('.custom-formspak-form__result');
        this._resultMsg = this._result?.querySelector('.msg');
        this._resultBack = this._result?.querySelector('.back');
        this._resultBack?.addEventListener('click', () => {
            // show form again
            this._result.hidden = true;
            this._form.style.display = '';
        });

        this._form.addEventListener("submit", this._onSubmit);
    }

    disconnectedCallback() {
        if (this._form) this._form.removeEventListener("submit", this._onSubmit);
        this._resultBack?.removeEventListener?.('click', this._backHandler);
    }

    _validateTurnstile() {
        const turnstileEl = this.querySelector(".cf-turnstile");
        const requireCaptcha = this.hasAttribute("require-turnstile") || this.hasAttribute("require-recaptcha");

        // If the widget isn't on the page
        if (!turnstileEl) {
            if (requireCaptcha) {
                return false;
            }
            return true;
        }

        // Token is injected by Turnstile into the form
        const tokenField = this._form?.querySelector('[name="cf-turnstile-response"]');
        const token = tokenField?.value?.trim();

        if (!token) {
            this._markCaptchaInvalid(turnstileEl, this.verifyNotRobotTxt);
            return false;
        }

        this._clearCaptchaInvalid(turnstileEl);
        return true;
    }


    _markCaptchaInvalid(captchaEl, msg) {
        captchaEl.classList.add("is-invalid");

        const msgEl = captchaEl.parentElement?.querySelector(".captcha-error, .recaptcha-error");
        if (msgEl && msg) msgEl.textContent = msg;
    }

    _clearCaptchaInvalid(captchaEl) {
        captchaEl.classList.remove("is-invalid");
    }


    async _onSubmit(e) {
        e.preventDefault();

        // Block submit if Turnstile not completed
        if (!this._validateTurnstile()) return;


        this.classList.add('loading')

        const action = this._form.getAttribute("action");
        if (!action) {
            console.error("[custom-formspark-form] Missing form action.");
            return;
        }

        // NEW: read attribute messages
        const successMessage = this.getAttribute("success-message") || "";
        const failureMessage = this.getAttribute("failure-message") || "";

        // Serialize fields -> JSON (arrays for repeated names)
        const data = Object.create(null);
        new FormData(this._form).forEach((value, key) => {
            if (value instanceof File) {
                // If you need real file upload, switch to multipart (ask and I will provide).
                if (!value.name && value.size === 0) return;
                value = value.name || "";
            }
            if (data[key] === undefined) data[key] = value;
            else Array.isArray(data[key]) ? data[key].push(value) : (data[key] = [data[key], value]);
        });

        // NEW: fetch IP + country (no DOM fields touched)
        try {
            const { ipAddress, countryName } = await new Promise((resolve) => {
                const request = new XMLHttpRequest();
                request.open("GET", "https://api.db-ip.com/v2/free/self", true);

                request.onload = function () {
                    if (request.status >= 200 && request.status < 400) {
                        const resp = JSON.parse(request.responseText);
                        resolve({ ipAddress: resp.ipAddress, countryName: resp.countryName });
                    } else {
                        resolve({ ipAddress: "Not provided", countryName: "Not provided" });
                    }
                };

                request.onerror = function () {
                    resolve({ ipAddress: "Not provided", countryName: "Not provided" });
                };

                request.send();
            });

            // Include in payload only
            data.user_ip = ipAddress;
            data.user_country = countryName;
        } catch {
            data.user_ip = "Not provided";
            data.user_country = "Not provided";
        }

        // NEW: include attribution values directly in payload (no inputs appended)
        const attrib = (() => {
            try {
                return JSON.parse(localStorage.getItem('rof_attribution') || '{}');
            } catch {
                return {};
            }
        })();

        // helper: assign if present, fallback to '-'
        const put = (name, value) => {
            data[name] = (typeof value === 'undefined' || value === null) ? '-' : value;
        };

        if (attrib.first) {
            put('utm_source_first',   attrib.first.utm_source);
            put('utm_medium_first',   attrib.first.utm_medium);
            put('utm_campaign_first', attrib.first.utm_campaign);
            put('utm_term_first',     attrib.first.utm_term);
            put('utm_content_first',  attrib.first.utm_content);
            // put('gclid_first',     attrib.first.gclid);
            // put('fbclid_first',    attrib.first.fbclid);
            put('landing_page_first', attrib.first.landing_page);
            put('referrer_first',     attrib.first.referrer);
            // put('device_type_first', attrib.first.device_type);
            put('timestamp_first',    attrib.first.timestamp);
        }

        if (attrib.last) {
            put('utm_source_last',   attrib.last.utm_source);
            put('utm_medium_last',   attrib.last.utm_medium);
            put('utm_campaign_last', attrib.last.utm_campaign);
            put('utm_term_last',     attrib.last.utm_term);
            put('utm_content_last',  attrib.last.utm_content);
            // put('gclid_last',     attrib.last.gclid);
            // put('fbclid_last',    attrib.last.fbclid);
            put('landing_page_last', attrib.last.landing_page);
            put('referrer_last',     attrib.last.referrer);
            // put('device_type_last', attrib.last.device_type);
            put('timestamp_last',    attrib.last.timestamp);
        }

        if (Number.isFinite(attrib.session_count)) {
            put('session_count', attrib.session_count.toString());
        }

        // Optional: disable submits during request
        const submits = this._form.querySelectorAll('[type="submit"], button:not([type]), button[type="submit"]');
        submits.forEach(b => (b.disabled = true));

        // SVGs (inline, kept minimal)
        const okSVG = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">
              <path d="M16,0C7.164,0,0,7.164,0,16s7.164,16,16,16s16-7.164,16-16S24.836,0,16,0z M13.52,23.383L6.158,16.02l2.828-2.828l4.533,4.535
              l9.617-9.617l2.828,2.828L13.52,23.383z" fill="currentColor"/>
            </svg>`;
        const errSVG = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" aria-hidden="true">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM10.1465 10.8536L7.50004 8.20714L4.85359 10.8536L4.14648 10.1465L6.79293 7.50004L4.14648 4.85359L4.85359 4.14648L7.50004 6.79293L10.1465 4.14648L10.8536 4.85359L8.20714 7.50004L10.8536 10.1465L10.1465 10.8536Z"
                fill="currentColor"/>
            </svg>`;


        fetch(action, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify(data),
        })
            .then((response) => {

                if(response.ok) {

                  this.showSuccess(response, data, okSVG, successMessage)
                } else {
                    this.showError('error', data, errSVG, failureMessage)
                }
            })
            .catch((error) => {
                this.showError(error, data, errSVG, failureMessage)
            })
            .finally(() => {
                submits.forEach(b => (b.disabled = false));
                this.classList.remove('loading')
            });
    }

    showError(error, data, errSVG, failureMessage) {

        if (this._result && this._resultMsg) {
            this._form.style.display = 'none';
            this._resultMsg.innerHTML = `${errSVG}<span>${failureMessage}</span>`;
            this._result.hidden = false;
        }
        this.dispatchEvent(new CustomEvent("formspark:error", {
            bubbles: true,
            detail: { error, data }
        }));
        console.error("[custom-formspark-form] ERROR", error);
    }

    showSuccess(response, data, okSVG, successMessage) {
        if (this._result && this._resultMsg) {
            this._form.style.display = 'none';
            this._resultMsg.innerHTML = `${okSVG}<span>${successMessage}</span>`;
            this._result.hidden = false;
        }

        this.dispatchEvent(new CustomEvent("formspark:success", {
            bubbles: true,
            detail: {response, data}
        }));
    }
}

customElements.define("custom-formspark-form", CustomFormsparkForm);
